import { getFrontendConfigLoader } from '@doxyme/config';
import { loadSegment } from '../../features/tracking/trackers/segment';

/**
 * Initializes Segment for standalone pages that need page-view tracking
 * without the full patient or provider application bootstrap.
 */
export const initializeSegmentPage = (): void =>
  typeof window !== 'undefined' ? initSegmentPage() : undefined;

const initSegmentPage = (): void => {
  loadSegment({
    apiKey: getFrontendConfigLoader().get('SEGMENT_API_KEY') as string,
    src: getFrontendConfigLoader().get('SEGMENT_SRC') as string,
    isProvider: false,
  });
};
